import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import {default as Autocomplete, createFilterOptions} from '@mui/material/Autocomplete';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';

const OPTIONS_LIMIT = 10;
const filterOptions = createFilterOptions({
  limit: OPTIONS_LIMIT
});

const shotNumbers = [...Array(2975).keys()].map((num) => (num + 1).toString());

export default function SearchAppBar(props) {
  const navigate = useNavigate();
  function onChange(event,value) {
    if(Number(value) > 0 && Number(value) <= 2974) {
      navigate(`/shots/${value}`);
      setDrawerOpen(false);
    }
  }

  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer =
    (open) =>
    (event) => {
      if (
        event.type === 'keydown' &&
        (event.key === 'Tab' ||
          event.key === 'Shift')
      ) {
        return;
      }

      setDrawerOpen(open);
  };

  const handleHomeButtonClick = () => {
    setDrawerOpen(false);
    navigate('/');
  };

  const handleExploreButtonClick = () => {
    setDrawerOpen(false);
    navigate('/shots');
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer(true)}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Drawer
            anchor="left"
            open={isDrawerOpen}
            onClose={toggleDrawer(false)}
          >
            <div className="search-bar">
              <SearchIcon />
              <Autocomplete
                id="shot-number-search"
                className="search-bar-input"
                disableClearable
                options={shotNumbers}
                filterOptions={filterOptions}
                onChange={onChange}
                renderInput={(params) => <TextField {...params} label="Enter shot #..." />}
              />
            </div>
            <List sx={{width: 250}}>
              <ListItem disablePadding>
                <ListItemButton onClick={handleHomeButtonClick}>
                  <ListItemText primary={"Home"} />
                </ListItemButton>
              </ListItem>
            </List>
            <List sx={{width: 250}}>
              <ListItem disablePadding>
                <ListItemButton onClick={handleExploreButtonClick}>
                  <ListItemText primary={"Explore"} />
                </ListItemButton>
              </ListItem>
            </List>
          </Drawer>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
          >
            Steph Curry's 2974 Three Pointers
          </Typography>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
